import { render, staticRenderFns } from "./privacyModal.vue?vue&type=template&id=6b3492cc&scoped=true"
import script from "./privacyModal.vue?vue&type=script&lang=js"
export * from "./privacyModal.vue?vue&type=script&lang=js"
import style0 from "./privacyModal.vue?vue&type=style&index=0&id=6b3492cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3492cc",
  null
  
)

export default component.exports